export const SuggestionStatus = Object.freeze({
  WAITING: 0,
  IN_PROGRESS: 1,
  DONE: 2,
});

export const isSuggestionStatus = (status) =>
  status === SuggestionStatus.WAITING ||
  status === SuggestionStatus.IN_PROGRESS ||
  status === SuggestionStatus.DONE;
